<template>
  <div class="pagination-wrapper">
    <el-select
      v-model="innerPageSize"
      @change="handleSizeChange"
      size="mini"
      class="page-size-select"
    >
      <el-option
        v-for="size in pageSizes"
        :key="size"
        :label="showItemsText(size)"
        :value="size"
      />
    </el-select>
    <div class="text-10">
     {{ displayRange }}
    </div>
    <el-pagination
      :total="total"
      :current-page="currentPage"
      :page-size="pageSize"
      :layout="layout"
      :prev-text="localPrevText"
      :next-text="localNextText"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>
<script>
import { defineComponent, ref, computed, watch } from '@vue/composition-api';

// update:がつくものはv-model連携用
const EMITS = {
  UPDATE_CURRENT_PAGE: 'update:currentPage',
  CHANGE_PAGE: 'page-changed',
  UPDATE_PAGESIZE: 'update:pageSize',
  SIZE_CHANGE: 'size-changed',
};

export default defineComponent({
  name: 'BasePagination',
  props: {
    lang: {
      type: String,
      default: "en",
    },
    total: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    prevText: {
      type: String,
      default: 'Prev',
    },
    nextText: {
      type: String,
      default: 'Next',
    },
    layout: {
      type: String,
      default: 'prev, pager, next, jumper',
    },
  },
  setup(props, { emit }) {
    const innerPageSize = ref(props.pageSize);
    watch(
      () => props.pageSize,
      val => {
        innerPageSize.value = val;
      },
    );
    const handlePageChange = val => {
      emit(EMITS.UPDATE_CURRENT_PAGE, val);
      emit(EMITS.CHANGE_PAGE, val);
    };
    const handleSizeChange = val => {
      innerPageSize.value = val;
      emit(EMITS.UPDATE_PAGESIZE, val);
      emit(EMITS.SIZE_CHANGE, val);
    };

    const displayRange = computed(() => {
      const from = (props.currentPage - 1) * props.pageSize + 1;
      const to = Math.min(props.currentPage * props.pageSize, props.total);
      return props.total === 0
        ? props.lang === 'ja' ? '0 件を表示中' : 'No results found'
        : props.lang === 'ja' ?
           `全 ${props.total} 件中 ${from} 件〜${to} 件を表示中`
           : `Showing ${from}-${to} of ${props.total}`;
    });

    const showItemsText = computed(()=>{
      return (size) => props.lang === 'ja' ? `${size}件表示` : `Show ${size} items`
    })

    const localPrevText = computed(()=>{
      if ( props.lang ) {
        return props.lang === 'ja' ? "前へ" : 'Prev'
      }
      else {
        return props.prevText
      }
    })

    const localNextText = computed(()=>{
      if ( props.lang ) {
        return props.lang === 'ja' ? "次へ" : 'Next'
      }
      else {
        return props.nextText
      }

    })

    return {
      innerPageSize,
      handlePageChange,
      handleSizeChange,
      displayRange,
      showItemsText,
      localPrevText,
      localNextText,
    };
  },
});
</script>
<style scoped>
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 1rem 0;
}
.page-size-select {
  width: 8rem;
}
</style>
